import { Observer } from 'gsap/Observer'
import { CustomEase } from 'gsap/CustomEase'
import { gsap, ScrollTrigger, ScrollSmoother } from '@dboxdev/ui-components/gsap'

// The package's /gsap subpath registers ScrollTrigger + ScrollSmoother on the
// shared gsap singleton. Observer isn't in that set but the panel navigation
// needs it, so it is registered here — same instance, once, as an import side
// effect. Import gsap through this module (not from 'gsap' directly) wherever
// Observer is involved, so the registration is guaranteed to have run.
gsap.registerPlugin(Observer, CustomEase)

// Figma's "Ease out" is cubic-bezier(0, 0, 0.58, 1) — the same curve CSS calls
// `ease-out`. GSAP has no built-in equivalent (`power1.out` is a quadratic and
// lands differently), so it is registered by name once, here, and used wherever
// a tween has to match a prototype easing.
CustomEase.create('figmaEaseOut', 'M0,0 C0,0 0.58,1 1,1')

export { gsap, ScrollTrigger, ScrollSmoother, Observer, CustomEase }
